import { render, staticRenderFns } from "./refund-rule.vue?vue&type=template&id=6f9c65fe&scoped=true&lang=pug&"
import script from "./refund-rule.vue?vue&type=script&lang=js&"
export * from "./refund-rule.vue?vue&type=script&lang=js&"
import style0 from "./refund-rule.vue?vue&type=style&index=0&id=6f9c65fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9c65fe",
  null
  
)

export default component.exports